import React from 'react';

const SaveStatusChip = ({ status, onRetry }) => {
    if (status === 'saving') return <span className="text-xs text-neutral-400">Saving…</span>;
    if (status === 'saved') return <span className="text-xs text-emerald-400">Saved ✓</span>;
    if (status === 'invalid') return <span className="text-xs text-amber-400">Not saved — check fields</span>;
    if (status === 'error') return (
        <span className="text-xs text-red-400 flex items-center gap-2">
            Couldn't save —
            <button onClick={onRetry} className="underline hover:text-red-300">Retry</button>
        </span>
    );
    return null;
};

export default SaveStatusChip;
